

import React from 'react';
import {withRouter, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from "react-bootstrap/Col";
import * as tableActions from '../../../../store/actions/table';
import { LogoFacebook } from 'react-ionicons';
import { LogoInstagram } from 'react-ionicons';
import Button from 'react-bootstrap/Button';
import { Globe } from 'react-ionicons';


class Details extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []
        }
    }

    componentDidMount(props) {

    }

    componentDidUpdate(props, state) {

    }

    links = [{
        key: 'url',
        logo: <Globe />
    },
        {
            key: 'fb',
            logo: <LogoFacebook />
        },
        {
            key: 'ig',
            logo: <LogoInstagram />
        }];

    render() {
        return (
            <div className={'page-container'}>
                <div className={'page-header'}>
                    <Row>
                        <Col>

                            <div className={"profile-right"}>
                                {this.links.map((item, i) => {
                                    return this.props.single.single[item.key] !== "" ? (
                                        <Button variant={"flat btn-circle"} as={Link} to={{pathname: this.props.single.single[item.key]}} target={"_blank"}>{item.logo}</Button>
                                    ) : null
                                })}
                            </div>
                            <div className={"profile-left"}>
                                <h1>About</h1>
                                <p>{this.props.single.single.about || 'No description available'}</p>
                            </div>

                        </Col>
                    </Row>
                </div>


            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    table: state.table,
    single: state.single
});

const mapDispatchToProps = dispatch => ({
    getTableData: (view, skip, limit, sort, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
    },
    getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
        dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
    },
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(Details));

class DetailsContainer extends React.Component {
    render() {
        return (
            <div>
                <Connected {...this.props} />
            </div>
        )
    }
}

export default DetailsContainer;
